// extracted by mini-css-extract-plugin
export default {"BaseLayoutContainer":"BaseLayout_BaseLayoutContainer__yopYo","BaseLayoutContent":"BaseLayout_BaseLayoutContent__R8A4j"};